exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".no-border {\n    border: none !important;\n}\n\n.logo {\n    height: 74px;\n}\n\n.title-head {\n    font-size: 2rem;\n}\n\n@media (max-width: 767px) {\n    /* CSS goes here */\n    .title-head {\n        font-size: 1rem;\n    }\n}\n\n.page-scroll-header {\n    background-color: #ccc !important;\n    opacity: 0.9;\n}\n\n.sub-header {\n    font-size: 1rem;\n    position: relative;\n}\n\n.tag {\n    font-size: 0.8rem;\n    font-style: italic;\n}\n\n.align-bottom-5 {\n    margin-top: 5%;\n}\n\n.page-scroll-header {\n    background-color: #241523fa !important;\n    opacity: 0.9;\n}\n\n.rightfloat {\n    float: right;\n}\n\n.text-green {\n    color: #a7ff9b!important;\n}\n\n.green {\n    color: #f1f3f1!important;\n}\n\n.f-size {\n    font-size: 24px;\n    color: #fff;\n}\n\n.adjs-padd {\n    padding: 7px;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/xampp/htdocs/Techbotz-master/src/app/app.component.css
// module id = ../../../../../src/app/app.component.css
// module chunks = main